import {
  AnnularRingFeatureTableOptions,
  AnnularRingFormFields,
  AnnularRingJSONFromFormFields,
  CircumferentialWeldFeatureTableOptions,
  CircumferentialWeldFormFields,
  CircumferentialWeldJSONFromFormFields,
  CoatingFormFields,
  CoatingJSONFromFormFields,
  CoatingRegionFeatureTableOptions,
  ConeCircumferentialWeldFeatureTableOptions,
  ConeCircumferentialWeldFormFields,
  ConeCircumferentialWeldJSONFromFormFields,
  ConeCourseFeatureTableOptions,
  ConeCourseFormFields,
  ConeCourseJSONFromFormFields,
  ConePlateFeatureTableOptions,
  ConeRadialWeldFeatureTableOptions,
  ConeRadialWeldFormFields,
  ConeRadialWeldJSONFromFormFields,
  ConicalPlateFormFields,
  ConicalPlateJSONFromFormFields,
  FeatureTableOptions,
  FixedSensorFeatureTableOptions,
  FixedSensorFormFields,
  FixedSensorJSONFromFormFields,
  FormField,
  GeckoFeatureModelType,
  GeckoFeaturesJSON,
  GenericHeadCircumferentialWeldFeatureTableOptions,
  GenericHeadCircumferentialWeldFormFields,
  GenericHeadCircumferentialWeldJSONFromFormFields,
  GenericHeadRadialWeldFeatureTableOptions,
  GenericHeadRadialWeldFormFields,
  GenericHeadRadialWeldJSONFromFormFields,
  getFormFieldByDataKey,
  HorizontalWeldFeatureTableOptions,
  HorizontalWeldJSONFromFormFields,
  HorizontalWeldModelFormFields,
  LeakDetectionValveFeatureTableOptions,
  LeakDetectionValveFormFields,
  LeakDetectionValveJSONFromFormFields,
  LegacyBoilerRepairRegionFeatureTableOptions,
  LegacyBoilerRepairRegionFormFields,
  LegacyBoilerRepairRegionJSONFromFormFields,
  LegacyBoilerWallFeatureTableOptions,
  LegacyBoilerWallFormFields,
  LegacyBoilerWallJSONFromFormFields,
  LegSupportFeatureTableOptions,
  LegSupportFormFields,
  LegSupportJSONFromFormFields,
  LinerFormFields,
  LinerJSONFromFormFields,
  LinerRegionFeatureTableOptions,
  ManwayFeatureTableOptions,
  ManwayFormFields,
  ManwayJSONFromFormFields,
  NewGeckoAnnularRingJSON,
  NewGeckoCircumferentialWeldJSON,
  NewGeckoCoatingJSON,
  NewGeckoConeCircumferentialWeldJSON,
  NewGeckoConeCourseJSON,
  NewGeckoConeRadialWeldJSON,
  NewGeckoConicalPlateJSON,
  NewGeckoCourseJSON,
  NewGeckoFixedSensorJSON,
  NewGeckoGenericHeadCircumferentialWeldJSON,
  NewGeckoGenericHeadRadialWeldJSON,
  NewGeckoHorizontalWeldJSON,
  NewGeckoLeakDetectionValveJSON,
  NewGeckoLegacyBoilerRepairRegionJSON,
  NewGeckoLegacyBoilerWallJSON,
  NewGeckoLegSupportJSON,
  NewGeckoLinerJSON,
  NewGeckoManwayJSON,
  NewGeckoNozzleJSON,
  NewGeckoPipeIntegralSupportJSON,
  NewGeckoPipeNonIntegralSupportJSON,
  NewGeckoPipeWrapJSON,
  NewGeckoPlateJSON,
  NewGeckoPolygonalPlateJSON,
  NewGeckoRectangularManwayJSON,
  NewGeckoSaddleSupportJSON,
  NewGeckoSeamWeldJSON,
  NewGeckoShipDeckBittJSON,
  NewGeckoShipDeckBulkheadJSON,
  NewGeckoShipDeckChockJSON,
  NewGeckoShipDeckCoamingJSON,
  NewGeckoShipDeckCompartmentJSON,
  NewGeckoShipDeckDoorJSON,
  NewGeckoShipDeckDrainJSON,
  NewGeckoShipDeckHatchJSON,
  NewGeckoShipDeckLadderJSON,
  NewGeckoShipDeckLockerJSON,
  NewGeckoSkirtSupportJSON,
  NewGeckoSphericalPlateJSON,
  NewGeckoTubePlateJSON,
  NewGeckoVerticalWeldJSON,
  NozzleFeatureTableOptions,
  NozzleFormFields,
  NozzleJSONFromFormFields,
  PipeIntegralSupportFeatureTableOptions,
  PipeIntegralSupportFormFields,
  PipeIntegralSupportJSONFromFormFields,
  PipeNonIntegralSupportFeatureTableOptions,
  PipeNonIntegralSupportFormFields,
  PipeNonIntegralSupportJSONFromFormFields,
  PipeWrapFeatureTableOptions,
  PipeWrapFormFields,
  PipeWrapJSONFromFormFields,
  PlateFeatureTableOptions,
  PlateFormFields,
  PlateJSONFromFormFields,
  PolygonalPlateFeatureTableOptions,
  PolygonalPlateFormFields,
  PolygonalPlateJSONFromFormFields,
  RectangularManwayFeatureTableOptions,
  RectangularManwayFormFields,
  RectangularManwayJSONFromFormFields,
  SaddleSupportFeatureTableOptions,
  SaddleSupportFormFields,
  SaddleSupportJSONFromFormFields,
  SeamWeldFeatureTableOptions,
  SeamWeldFormFields,
  SeamWeldJSONFromFormFields,
  ShellCourseFeatureTableOptions,
  ShellCourseFormFields,
  ShellCourseJSONFromFormFields,
  ShipDeckBittFeatureTableOptions,
  ShipDeckBittFormFields,
  ShipDeckBittJSONFromForm,
  ShipDeckBulkheadFeatureTableOptions,
  ShipDeckBulkheadFormFields,
  ShipDeckBulkheadJSONFromFormFields,
  ShipDeckChockFeatureTableOptions,
  ShipDeckChockFormFields,
  ShipDeckChockJSONFromFormFields,
  ShipDeckCoamingFeatureTableOptions,
  ShipDeckCoamingFormFields,
  ShipDeckCoamingJSONFromFormFields,
  ShipDeckCompartmentFeatureTableOptions,
  ShipDeckCompartmentFormFields,
  ShipDeckCompartmentJSONFromFormFields,
  ShipDeckDoorFeatureTableOptions,
  ShipDeckDoorFormFields,
  ShipDeckDoorJSONFromFormFields,
  ShipDeckDrainFeatureTableOptions,
  ShipDeckDrainFormFields,
  ShipDeckDrainJSONFromFormFields,
  ShipDeckHatchFeatureTableOptions,
  ShipDeckHatchFormFields,
  ShipDeckHatchJSONFromFormFields,
  ShipDeckLadderFeatureTableOptions,
  ShipDeckLadderFormFields,
  ShipDeckLadderJSONFromFormFields,
  ShipDeckLockerFeatureTableOptions,
  ShipDeckLockerFormFields,
  ShipDeckLockerJSONFromFormFields,
  SkirtSupportFeatureTableOptions,
  SkirtSupportFormFields,
  SkirtSupportJSONFromFormFields,
  SortTableByField,
  SphericalPlateFeatureTableOptions,
  SphericalPlateFormFields,
  SphericalPlateJSONFromFormFields,
  TubePlateFeatureTableOptions,
  TubePlateFormFields,
  TubePlateJSONFromFormFields,
  VerticalWeldFeatureTableOptions,
  VerticalWeldJSONFromFormFields,
  VerticalWeldModelFormFields,
} from 'types'

export const getFormFieldsForFeatureType = (
  feature: GeckoFeaturesJSON
): FormField[] => {
  const featureType = feature.type
  switch (featureType) {
    case GeckoFeatureModelType.VerticalWeld:
      return VerticalWeldModelFormFields(feature)
    case GeckoFeatureModelType.HorizontalWeld:
      return HorizontalWeldModelFormFields(feature)
    case GeckoFeatureModelType.Plate:
      return PlateFormFields(feature)
    case GeckoFeatureModelType.TubePlate:
      return TubePlateFormFields(feature)
    case GeckoFeatureModelType.Nozzle:
      return NozzleFormFields(feature)
    case GeckoFeatureModelType.Manway:
      return ManwayFormFields(feature)
    case GeckoFeatureModelType.RectangularManway:
      return RectangularManwayFormFields(feature)
    case GeckoFeatureModelType.FixedSensor:
      return FixedSensorFormFields(feature)
    case GeckoFeatureModelType.PolygonalPlate:
      return PolygonalPlateFormFields(feature)
    case GeckoFeatureModelType.LegacyBoilerRepairRegion:
      return LegacyBoilerRepairRegionFormFields(feature)
    case GeckoFeatureModelType.LegacyBoilerWall:
      return LegacyBoilerWallFormFields(feature)
    case GeckoFeatureModelType.ConeCourse:
      return ConeCourseFormFields(feature)
    case GeckoFeatureModelType.Course:
      return ShellCourseFormFields(feature)
    case GeckoFeatureModelType.ConeCircumferentialWeld:
      return ConeCircumferentialWeldFormFields(feature)
    case GeckoFeatureModelType.ConeRadialWeld:
      return ConeRadialWeldFormFields(feature)
    case GeckoFeatureModelType.ShipDeckCompartment:
      return ShipDeckCompartmentFormFields(feature)
    case GeckoFeatureModelType.ShipDeckBitt:
      return ShipDeckBittFormFields(feature)
    case GeckoFeatureModelType.ShipDeckCoaming:
      return ShipDeckCoamingFormFields(feature)
    case GeckoFeatureModelType.ShipDeckChock:
      return ShipDeckChockFormFields(feature)
    case GeckoFeatureModelType.ShipDeckHatch:
      return ShipDeckHatchFormFields(feature)
    case GeckoFeatureModelType.ShipDeckLocker:
      return ShipDeckLockerFormFields(feature)
    case GeckoFeatureModelType.ShipDeckDrain:
      return ShipDeckDrainFormFields(feature)
    case GeckoFeatureModelType.ShipDeckLadder:
      return ShipDeckLadderFormFields(feature)
    case GeckoFeatureModelType.ShipDeckBulkhead:
      return ShipDeckBulkheadFormFields(feature)
    case GeckoFeatureModelType.ShipDeckDoor:
      return ShipDeckDoorFormFields(feature)
    case GeckoFeatureModelType.SeamWeld:
      return SeamWeldFormFields(feature)
    case GeckoFeatureModelType.CircumferentialWeld:
      return CircumferentialWeldFormFields(feature)
    case GeckoFeatureModelType.GenericHeadCircumferentialWeld:
      return GenericHeadCircumferentialWeldFormFields(feature)
    case GeckoFeatureModelType.GenericHeadRadialWeld:
      return GenericHeadRadialWeldFormFields(feature)
    case GeckoFeatureModelType.PipeNonIntegralSupport:
      return PipeNonIntegralSupportFormFields(feature)
    case GeckoFeatureModelType.PipeIntegralSupport:
      return PipeIntegralSupportFormFields(feature)
    case GeckoFeatureModelType.PipeWrap:
      return PipeWrapFormFields(feature)
    case GeckoFeatureModelType.ConePlate:
      return ConicalPlateFormFields(feature)
    case GeckoFeatureModelType.CoatingRegion:
      return CoatingFormFields(feature)
    case GeckoFeatureModelType.SphericalPlate:
      return SphericalPlateFormFields(feature)
    case GeckoFeatureModelType.LeakDetectionValve:
      return LeakDetectionValveFormFields(feature)
    case GeckoFeatureModelType.LinerRegion:
      return LinerFormFields(feature)
    case GeckoFeatureModelType.AnnularRing:
      return AnnularRingFormFields(feature)
    case GeckoFeatureModelType.SkirtSupport:
      return SkirtSupportFormFields(feature)
    case GeckoFeatureModelType.SaddleSupport:
      return SaddleSupportFormFields(feature)
    case GeckoFeatureModelType.LegSupport:
      return LegSupportFormFields(feature)
    default:
      throw new Error(`Unsupported feature type: ${featureType}`)
  }
}

export const getJSONFromFeatureFormFields = (
  featureType: GeckoFeatureModelType,
  formFields: FormField[]
): GeckoFeaturesJSON => {
  switch (featureType) {
    case GeckoFeatureModelType.Course:
      return ShellCourseJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ConeCourse:
      return ConeCourseJSONFromFormFields(formFields)
    case GeckoFeatureModelType.Plate:
      return PlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.TubePlate:
      return TubePlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PolygonalPlate:
      return PolygonalPlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ConePlate:
      return ConicalPlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.VerticalWeld:
      return VerticalWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.HorizontalWeld:
      return HorizontalWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ConeCircumferentialWeld:
      return ConeCircumferentialWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ConeRadialWeld:
      return ConeRadialWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.SeamWeld:
      return SeamWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.CircumferentialWeld:
      return CircumferentialWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.GenericHeadCircumferentialWeld:
      return GenericHeadCircumferentialWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.GenericHeadRadialWeld:
      return GenericHeadRadialWeldJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckCompartment:
      return ShipDeckCompartmentJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckBitt:
      return ShipDeckBittJSONFromForm(formFields)
    case GeckoFeatureModelType.ShipDeckCoaming:
      return ShipDeckCoamingJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckChock:
      return ShipDeckChockJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckHatch:
      return ShipDeckHatchJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckLocker:
      return ShipDeckLockerJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckDrain:
      return ShipDeckDrainJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckLadder:
      return ShipDeckLadderJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckBulkhead:
      return ShipDeckBulkheadJSONFromFormFields(formFields)
    case GeckoFeatureModelType.ShipDeckDoor:
      return ShipDeckDoorJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PipeNonIntegralSupport:
      return PipeNonIntegralSupportJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PipeIntegralSupport:
      return PipeIntegralSupportJSONFromFormFields(formFields)
    case GeckoFeatureModelType.PipeWrap:
      return PipeWrapJSONFromFormFields(formFields)
    case GeckoFeatureModelType.Nozzle:
      return NozzleJSONFromFormFields(formFields)
    case GeckoFeatureModelType.Manway:
      return ManwayJSONFromFormFields(formFields)
    case GeckoFeatureModelType.RectangularManway:
      return RectangularManwayJSONFromFormFields(formFields)
    case GeckoFeatureModelType.FixedSensor:
      return FixedSensorJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LegacyBoilerRepairRegion:
      return LegacyBoilerRepairRegionJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LegacyBoilerWall:
      return LegacyBoilerWallJSONFromFormFields(formFields)
    case GeckoFeatureModelType.CoatingRegion:
      return CoatingJSONFromFormFields(formFields)
    case GeckoFeatureModelType.SphericalPlate:
      return SphericalPlateJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LeakDetectionValve:
      return LeakDetectionValveJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LinerRegion:
      return LinerJSONFromFormFields(formFields)
    case GeckoFeatureModelType.AnnularRing:
      return AnnularRingJSONFromFormFields(formFields)
    case GeckoFeatureModelType.SkirtSupport:
      return SkirtSupportJSONFromFormFields(formFields)
    case GeckoFeatureModelType.SaddleSupport:
      return SaddleSupportJSONFromFormFields(formFields)
    case GeckoFeatureModelType.LegSupport:
      return LegSupportJSONFromFormFields(formFields)
    default:
      throw new Error(`Unsupported feature type: ${featureType}`)
  }
}

export const getNewJSONForFeatureType = (
  featureType: GeckoFeatureModelType
): GeckoFeaturesJSON => {
  switch (featureType) {
    case GeckoFeatureModelType.VerticalWeld:
      return NewGeckoVerticalWeldJSON
    case GeckoFeatureModelType.HorizontalWeld:
      return NewGeckoHorizontalWeldJSON
    case GeckoFeatureModelType.Plate:
      return NewGeckoPlateJSON
    case GeckoFeatureModelType.TubePlate:
      return NewGeckoTubePlateJSON
    case GeckoFeatureModelType.Nozzle:
      return NewGeckoNozzleJSON
    case GeckoFeatureModelType.Manway:
      return NewGeckoManwayJSON
    case GeckoFeatureModelType.RectangularManway:
      return NewGeckoRectangularManwayJSON
    case GeckoFeatureModelType.FixedSensor:
      return NewGeckoFixedSensorJSON
    case GeckoFeatureModelType.PolygonalPlate:
      return NewGeckoPolygonalPlateJSON
    case GeckoFeatureModelType.LegacyBoilerRepairRegion:
      return NewGeckoLegacyBoilerRepairRegionJSON
    case GeckoFeatureModelType.LegacyBoilerWall:
      return NewGeckoLegacyBoilerWallJSON
    case GeckoFeatureModelType.ConeCourse:
      return NewGeckoConeCourseJSON
    case GeckoFeatureModelType.Course:
      return NewGeckoCourseJSON
    case GeckoFeatureModelType.ConeCircumferentialWeld:
      return NewGeckoConeCircumferentialWeldJSON
    case GeckoFeatureModelType.ConeRadialWeld:
      return NewGeckoConeRadialWeldJSON
    case GeckoFeatureModelType.ShipDeckCompartment:
      return NewGeckoShipDeckCompartmentJSON
    case GeckoFeatureModelType.ShipDeckBitt:
      return NewGeckoShipDeckBittJSON
    case GeckoFeatureModelType.ShipDeckCoaming:
      return NewGeckoShipDeckCoamingJSON
    case GeckoFeatureModelType.ShipDeckChock:
      return NewGeckoShipDeckChockJSON
    case GeckoFeatureModelType.ShipDeckHatch:
      return NewGeckoShipDeckHatchJSON
    case GeckoFeatureModelType.ShipDeckLocker:
      return NewGeckoShipDeckLockerJSON
    case GeckoFeatureModelType.ShipDeckDrain:
      return NewGeckoShipDeckDrainJSON
    case GeckoFeatureModelType.ShipDeckLadder:
      return NewGeckoShipDeckLadderJSON
    case GeckoFeatureModelType.ShipDeckBulkhead:
      return NewGeckoShipDeckBulkheadJSON
    case GeckoFeatureModelType.ShipDeckDoor:
      return NewGeckoShipDeckDoorJSON
    case GeckoFeatureModelType.SeamWeld:
      return NewGeckoSeamWeldJSON
    case GeckoFeatureModelType.CircumferentialWeld:
      return NewGeckoCircumferentialWeldJSON
    case GeckoFeatureModelType.GenericHeadCircumferentialWeld:
      return NewGeckoGenericHeadCircumferentialWeldJSON
    case GeckoFeatureModelType.GenericHeadRadialWeld:
      return NewGeckoGenericHeadRadialWeldJSON
    case GeckoFeatureModelType.PipeNonIntegralSupport:
      return NewGeckoPipeNonIntegralSupportJSON
    case GeckoFeatureModelType.PipeIntegralSupport:
      return NewGeckoPipeIntegralSupportJSON
    case GeckoFeatureModelType.PipeWrap:
      return NewGeckoPipeWrapJSON
    case GeckoFeatureModelType.ConePlate:
      return NewGeckoConicalPlateJSON
    case GeckoFeatureModelType.CoatingRegion:
      return NewGeckoCoatingJSON
    case GeckoFeatureModelType.SphericalPlate:
      return NewGeckoSphericalPlateJSON
    case GeckoFeatureModelType.LeakDetectionValve:
      return NewGeckoLeakDetectionValveJSON
    case GeckoFeatureModelType.LinerRegion:
      return NewGeckoLinerJSON
    case GeckoFeatureModelType.AnnularRing:
      return NewGeckoAnnularRingJSON
    case GeckoFeatureModelType.SkirtSupport:
      return NewGeckoSkirtSupportJSON
    case GeckoFeatureModelType.SaddleSupport:
      return NewGeckoSaddleSupportJSON
    case GeckoFeatureModelType.LegSupport:
      return NewGeckoLegSupportJSON
  }
}

export function getFeatureTableOptionsByType(
  type: GeckoFeatureModelType
): FeatureTableOptions {
  switch (type) {
    case GeckoFeatureModelType.Course:
      return ShellCourseFeatureTableOptions
    case GeckoFeatureModelType.Plate:
      return PlateFeatureTableOptions
    case GeckoFeatureModelType.TubePlate:
      return TubePlateFeatureTableOptions
    case GeckoFeatureModelType.Nozzle:
      return NozzleFeatureTableOptions
    case GeckoFeatureModelType.Manway:
      return ManwayFeatureTableOptions
    case GeckoFeatureModelType.RectangularManway:
      return RectangularManwayFeatureTableOptions
    case GeckoFeatureModelType.FixedSensor:
      return FixedSensorFeatureTableOptions
    case GeckoFeatureModelType.VerticalWeld:
      return VerticalWeldFeatureTableOptions
    case GeckoFeatureModelType.HorizontalWeld:
      return HorizontalWeldFeatureTableOptions
    case GeckoFeatureModelType.SeamWeld:
      return SeamWeldFeatureTableOptions
    case GeckoFeatureModelType.CircumferentialWeld:
      return CircumferentialWeldFeatureTableOptions
    case GeckoFeatureModelType.GenericHeadCircumferentialWeld:
      return GenericHeadCircumferentialWeldFeatureTableOptions
    case GeckoFeatureModelType.GenericHeadRadialWeld:
      return GenericHeadRadialWeldFeatureTableOptions
    case GeckoFeatureModelType.PipeIntegralSupport:
      return PipeIntegralSupportFeatureTableOptions
    case GeckoFeatureModelType.PipeNonIntegralSupport:
      return PipeNonIntegralSupportFeatureTableOptions
    case GeckoFeatureModelType.PipeWrap:
      return PipeWrapFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckCompartment:
      return ShipDeckCompartmentFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckBitt:
      return ShipDeckBittFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckCoaming:
      return ShipDeckCoamingFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckChock:
      return ShipDeckChockFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckHatch:
      return ShipDeckHatchFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckLocker:
      return ShipDeckLockerFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckDrain:
      return ShipDeckDrainFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckLadder:
      return ShipDeckLadderFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckBulkhead:
      return ShipDeckBulkheadFeatureTableOptions
    case GeckoFeatureModelType.ShipDeckDoor:
      return ShipDeckDoorFeatureTableOptions
    case GeckoFeatureModelType.LegacyBoilerWall:
      return LegacyBoilerWallFeatureTableOptions
    case GeckoFeatureModelType.ConeCourse:
      return ConeCourseFeatureTableOptions
    case GeckoFeatureModelType.ConePlate:
      return ConePlateFeatureTableOptions
    case GeckoFeatureModelType.ConeCircumferentialWeld:
      return ConeCircumferentialWeldFeatureTableOptions
    case GeckoFeatureModelType.ConeRadialWeld:
      return ConeRadialWeldFeatureTableOptions
    case GeckoFeatureModelType.LegacyBoilerRepairRegion:
      return LegacyBoilerRepairRegionFeatureTableOptions
    case GeckoFeatureModelType.PolygonalPlate:
      return PolygonalPlateFeatureTableOptions
    case GeckoFeatureModelType.CoatingRegion:
      return CoatingRegionFeatureTableOptions
    case GeckoFeatureModelType.SphericalPlate:
      return SphericalPlateFeatureTableOptions
    case GeckoFeatureModelType.LeakDetectionValve:
      return LeakDetectionValveFeatureTableOptions
    case GeckoFeatureModelType.LinerRegion:
      return LinerRegionFeatureTableOptions
    case GeckoFeatureModelType.AnnularRing:
      return AnnularRingFeatureTableOptions
    case GeckoFeatureModelType.SkirtSupport:
      return SkirtSupportFeatureTableOptions
    case GeckoFeatureModelType.SaddleSupport:
      return SaddleSupportFeatureTableOptions
    case GeckoFeatureModelType.LegSupport:
      return LegSupportFeatureTableOptions
    default:
      throw new Error(`Unsupported feature type: ${type}`)
  }
}

export function getSortedFeatureList(
  featureJSON: Record<string, GeckoFeaturesJSON>,
  sortBy: SortTableByField[] | undefined
): [string, GeckoFeaturesJSON][] {
  const sortedFeatureList = Object.entries(featureJSON)
  if (sortBy && sortBy.length > 0) {
    // Sort the array of entries based on the criteria specified in sortBy
    sortedFeatureList.sort((featureTupleA, featureTupleB) => {
      const featureA = featureTupleA[1]
      const featureB = featureTupleB[1]
      for (let i = 0; i < sortBy.length; i++) {
        const { fieldName, order } = sortBy[i]
        const aFields = getFormFieldsForFeatureType(featureA)
        const bFields = getFormFieldsForFeatureType(featureB)
        const aValue = getFormFieldByDataKey(aFields, fieldName)
          ?.value as number
        const bValue = getFormFieldByDataKey(bFields, fieldName)
          ?.value as number

        if (aValue < bValue) {
          return order === 'asc' ? -1 : 1
        } else if (aValue > bValue) {
          return order === 'asc' ? 1 : -1
        }
      }
      // If no differences are found for the given sort fields, return 0, meaning equal
      return 0
    })
  }

  return sortedFeatureList
}
